import { useSelector } from 'react-redux'

import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { SortOrder } from '@/app/types'

export type GroupsQuery = {
  page?: number
  size?: number
  search?: string
  sortBy?: string
  direction?: SortOrder
}

type Options = {
  skip?: boolean
}

export const useGetGroups = (query: GroupsQuery = {}, options: Options = {}) => {
  const orgId = useSelector(selectOrgId)

  return esApi.endpoints.getOrgGroupsList.useQuery(
    {
      direction: 'ASC',
      orgId: orgId?.toString(),
      sortBy: 'name',
      type: 'NORMAL',
      ...query,
    },
    { skip: !orgId || options.skip },
  )
}
